import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import useTitle from "@/hooks/useTitle"
import EtBtnFormBasic from "@/components/common/buttons/EtBtnFormBasic"
import PulseLoader from "react-spinners/PulseLoader"
import Modal from "@/components/common/modal/Modal"
import { useGetContactOrganizationsQuery, useDeleteContactOrganizationMutation } from "./contactOrganizationsApiSlice"

const EtDeleteContactOrganization = ({id, setActiveAdminView}) => {
  // Created - 27 Sep 2024
  // Author - Atul Pandey
  // Updated - 07 Mar 2025 - updated the comp with props - { id, setActiveAdminView}
  // Updated - 07 Mar 2025 - switched from navigate to setActiveAdminView

  // 1 - Set Title
  useTitle("Delete Contact Organization")

  // 2 - extract the contactOrganization Id from the url
  // const { id } = useParams()
  //console.log("id:", id)

  // 3 - Extract the contactOrganization from the query to load the contactOrganization data
  const { contactOrganization } = useGetContactOrganizationsQuery("ContactOrganization", {
    selectFromResult: ({ data }) => ({
      contactOrganization: data?.entities[id],
    }),
  })

  //console.log('contact organization:', contactOrganization)

  // 4 - Check for returned data
  if (!contactOrganization) {
    return <PulseLoader color={"#ea580c"} />
  }

  // 5. Display data
  let content
  content = <EtDeleteContactOrganizationForm contactOrganization={contactOrganization} id={id} setActiveAdminView={setActiveAdminView}/> // 07 Mar 2025 - added setActiveAdminView={setActiveAdminView}
  return content
}

const EtDeleteContactOrganizationForm = ({contactOrganization, id, setActiveAdminView}) => {

  // 1 - set the variable for navigate
  const navigate = useNavigate()

 // 1a - Delete section modal 
 const [isModalOpen, setIsModalOpen] = useState(false)


  // 2 - set the mutation to create the new section data
  const[deleteContactOrganization, {
    isLoading,
    isSuccess,
    isError,
    error,
  }] = useDeleteContactOrganizationMutation()

// 3 - set the form data object
const [formData, setFormData] = useState({
  contactOrganizationName: contactOrganization.contactOrganizationName,
})

//console.log('formData for update:', formData)

// 4 - Reset form upon successful submission
useEffect(() => {
  if(isSuccess) {
    setFormData({
      contactOrganizationName: "",
    })

    // navigate('/contactOrganizations')
    setActiveAdminView('contactOrganizations'); // 07 Mar 2025
  }
  
  },[isSuccess])// ✅ 07 Mar 2025 - Removed `navigate` since it's no longer used.

// 5 - Form field updates / change handling

const handleChange = (e) => {
  const { name, value, files } = e.target
  if (name === "pic") {
    setFormData(prevState => ({ ...prevState, pic: files[0] }))
  } else {
    setFormData(prevState => ({ ...prevState, [name]: value }))
  }
}

// Modal management functions
const handleOpenModal = () => setIsModalOpen(true)
const handleCloseModal = () => setIsModalOpen(false)

// 7 - Form Submit Logic
const handleConfirm = async (e) => {
  e.preventDefault()
  handleCloseModal()

  // Initialize an object to collect the form data
  const contactOrganizationData = {
    contactOrganizationName: formData.contactOrganizationName,
  }
    // No image, send other data as is
    try {
      contactOrganizationData.id = id
      console.log("Form submitted.")
      await deleteContactOrganization(contactOrganizationData).unwrap() // Dispatch the RTK Query mutation
    } catch (error) {
      console.error(error)
    }
}

// 8 - Handle Cancel

const handleCancel = () => {
  // navigate('/contactOrganizations')
  setActiveAdminView('contactOrganizations'); // 07 Mar 2025
}


return (
  <div className="bg-gray-200 p-1 mx-auto mt-5 rounded-lg shadow-md shadow-black">
    {isLoading && <PulseLoader color={"#ea580c"} />}
    {isError && (
      <p className="text-orange-700 font-semi-bold py-2">
        {error?.data?.message}
      </p>
    )}
    <div className="bg-white p-1 m-1 rounded">
      <p className="p-1 m-1 font-bold font-poppins text-xl">Update a Contact Organization</p>

      <div className="bg-gray-200 rounded m-1 p-1">
        <form
          onSubmit={handleOpenModal}
          className="m-1 p-1 text-xs font-poppins"
        >
          
          <div id="contactOrganizationName">
            <input
              type="text"
              name="contactOrganizationName"
              placeholder="Enter the contact organization name here"
              value={formData.contactOrganizationName}
              onChange={handleChange}
              className="w-full rounded p-2 m-1"
              readOnly
            />
          </div>

          <div id="contacts" className="bg-white m-1 px-1 py-3 rounded">
            <EtBtnFormBasic
              name={"Delete"}
              type={"create"}
              handleClick={handleOpenModal}
            />
            <EtBtnFormBasic
              name={"Cancel"}
              type={"cancel"}
              handleClick={handleCancel}
            />
          </div>
        </form>
      </div>
    </div>
    <Modal isOpen={isModalOpen} onClose={handleCloseModal} onConfirm={handleConfirm} />
  </div>
)

}

export default EtDeleteContactOrganization